var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-tree"},_vm._l((_vm.stages),function(stage){return _c('VNode',{key:stage.id,attrs:{"stage":stage,"selected":_vm.selected},on:{"selectStage":_vm.selectStage}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }